import React, { useState } from 'react';

import { Button, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useIntl } from 'react-intl';
import { IAddressData, IChallengeCheckoutProduct } from 'src/shared/models';
import { capitalizeFirstLetter, checkUserResourcePoints } from 'utils';
import { ChallengeTypeEnum } from 'src/shared/enums';

interface OwnProps {
  selectedAddress: IAddressData;
  buttonDisabled: boolean;
  challengeType: ChallengeTypeEnum;
  checkoutName: string;
  loading: boolean;
  performCheckout: () => void;
  product?: IChallengeCheckoutProduct;
  singleProduct: boolean;
  type: number | null;
  termsLabel: string;
  termsUrl: string;
  userPoints: number;
}

export default function CheckoutDetails({
  selectedAddress,
  buttonDisabled,
  challengeType,
  checkoutName,
  loading,
  performCheckout,
  product,
  singleProduct,
  type,
  termsLabel,
  termsUrl,
  userPoints,
}: OwnProps) {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const { formatMessage } = useIntl();

  const showErrorAddress = () => {
    return termsAccepted && !selectedAddress;
  };

  const showButton = Boolean(type);

  const hasUserEnoughPoints = checkUserResourcePoints(
    userPoints,
    product?.score,
    challengeType,
  );

  const pointsLabel = Math.abs(product?.score);

  const handleCheck = (ev: CheckboxChangeEvent) => {
    setTermsAccepted(ev.target.checked);
  };

  const getTitle = () => {
    if (singleProduct) return product.lead;
    return `${capitalizeFirstLetter(checkoutName)} ${product.lead}`;
  };

  return (
    <div className="checkout-modal-details">
      {product && (
        <>
          <div className="checkout-product__title not_show_on_desktop">
            {formatMessage({ id: 'page.experience.checkout.summary-label' })}
          </div>
          <div className="rounded-card-product checkout-product">
            <div className="checkout-product__header">
              <div className="checkout-product__header--image">
                <img alt="" src={product.img} />
              </div>
              <span className="checkout-product__header--product-name">
                {getTitle()}
              </span>
              <span className="checkout-product__header--points">
                {formatMessage(
                  { id: 'page.experience.checkout.summary-points' },
                  { points: pointsLabel },
                )}
              </span>
            </div>
            <div className="checkout-product__description">
              <div>&nbsp;</div>
              <div className="checkout-product__description--content">
                {product.description}
              </div>
            </div>
          </div>

          {showButton && (
            <>
              <div className="checkout-btn__wrapper">
                <div className="checkout-product__terms">
                  <Checkbox
                    checked={termsAccepted}
                    className="checkbox-remember-login"
                    onChange={handleCheck}>
                    <span className="checkout-product__terms--content">
                      {formatMessage({
                        id: 'page.experience.checkout.summary-terms',
                      })}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={termsUrl}
                        className="link underline-text">
                        {termsLabel}
                      </a>
                    </span>
                  </Checkbox>
                </div>
                {type !== null && (
                  <Button
                    id="checkout-basic-modal-send"
                    className="btn-primary btn-primary--black btn-primary__small checkout-modal-send"
                    disabled={
                      buttonDisabled || !termsAccepted || !hasUserEnoughPoints
                    }
                    loading={loading}
                    onClick={performCheckout}>
                    {formatMessage(
                      { id: 'page.experience.checkout.button' },
                      { points: pointsLabel },
                    )}
                  </Button>
                )}
                {showErrorAddress() && (
                <p className="checkout-details__error-message ant-form-item-explain">{formatMessage({ id: 'page.experience.checkout.label-no-field' })}</p>
              )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
